<template>
    <div>
        <div class="indexcon">
            <banner :banner="bannerList"></banner>
        </div>
        <div class="cates">
            <div class="catesCon flx alc jsc">
                <div class="cateItem flx alc" v-for="v,i in cate1" @click="scanThis(i,v.id)">
                    <div class="cateLeft">
                        <img :src="$img(v.pc_icon)" alt="" />
                    </div>
                    <div class="catgeRight">
                        <div class="cateName" v-text="v.name">
                            
                        </div>
                        <div class="cateTitle" v-text="v.title">
                            
                        </div>
                    </div>
                    <div class="cshu" v-if="i < (cate1.length - 1)"></div>
                </div>
            </div>
           
        </div>
        <div class="mains" v-if="category_id == 0">
            <div class="titles flx alc jsb" v-if="recos.length > 0">
                <div class="titleft">
                    精品推荐
                </div>
                <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt="" @click="checkMore(5)" />
            </div>
            <div class="listCon flx alc">
                <div class="reItem" v-for="item,index in recos" :style="(index + 1) % 4 == 0?'margin-right:0' : ''" @click="toDetail(item)">
                    <div class="labelName" v-text="item.label" v-if="item.label">
            
                    </div>
                    <div class="reImg">
                        <img :src="$img(item.pc_avatar)" alt="" />
                    </div>
                    <div class="reInfo">
                        <div class="reName multy2" v-text="item.name">
            
                        </div>
                        <div class="reTitle single" v-text="item.title">
            
                        </div>
                        <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
                            <!-- (item.current_time < item.over_time) &&  -->
                            <div class="rebtn" v-if="item.is_type == 3">
                                马上预约
                            </div>
                            <div class="rebtn" v-if="item.is_type == 2">
                                观看回放
                            </div>
                            <div class="rebtn" v-if="item.is_type == 1">
                                了解课程
                            </div>
							<div class="rebtn" v-if="item.is_type == 4">
							    马上观看
							</div>
                           <!-- <div class="rebtn dsb" v-if="item.current_time > item.over_time">
                                直播结束
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mains" v-if="category_id != 0">
			
			<div class="titles flx alc jsb" v-if="list5.length > 0">
			    <div class="titleft">
			        精选推荐
			    </div>
			    <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt="" @click="checkMore(4)" />
			</div>
			<div class="listCon flx alc"  v-if="list5.length > 0">
			    <div class="reItem" v-for="item,index in list5" :style="(index + 1) % 4 == 0?'margin-right:0' : ''" @click="toDetail(item)">
			        <div class="labelName" v-text="item.label" v-if="item.label">
			
			        </div>
			        <div class="reImg">
			            <img :src="$img(item.pc_avatar)" alt="" />
			        </div>
			        <div class="reInfo">
			            <div class="reName multy2" v-text="item.name">
			
			            </div>
			            <div class="reTitle single" v-text="item.title">
			
			            </div>
			            <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
			                <div class="rebtn">
			                    马上观看
			                </div>
			               <!-- <div class="rebtn dsb" v-if="item.current_time > item.over_time">
			                    直播结束
			                </div> -->
			            </div>
			        </div>
			    </div>
			</div>
			
            <div class="titles flx alc jsb" v-if="list2.length > 0">
                <div class="titleft">
                    最新直播
                </div>
                <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt="" @click="checkMore(3)" />
            </div>
            <div class="listCon flx alc"  v-if="list2.length > 0">
                <div class="reItem" v-for="item,index in list2" :style="(index + 1) % 4 == 0?'margin-right:0' : ''" @click="toDetail(item)">
                    <div class="labelName" v-text="item.label" v-if="item.label">
            
                    </div>
                    <div class="reImg">
                        <img :src="$img(item.pc_avatar)" alt="" />
                    </div>
                    <div class="reInfo">
                        <div class="reName multy2" v-text="item.name">
            
                        </div>
                        <div class="reTitle single" v-text="item.title">
            
                        </div>
                        <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
                            <div class="rebtn">
                                马上预约
                            </div>
                           <!-- <div class="rebtn dsb" v-if="item.current_time > item.over_time">
                                直播结束
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="titles flx alc jsb"  v-if="list1.length > 0">
                <div class="titleft">
                    精品回放
                </div>
                <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt="" @click="checkMore(2)" />
            </div>
            <div class="listCon flx alc"  v-if="list1.length > 0">
                <div class="reItem" v-for="item,index in list1" :style="(index + 1) % 4 == 0?'margin-right:0' : ''" @click="toDetail(item)">
                    <div class="labelName" v-text="item.label" v-if="item.label"></div>
                    <div class="reImg">
                        <img :src="$img(item.pc_avatar)" alt="" />
                        <div class="reimgMask">
                            <img :src="$Localimg('play.png')" alt="">
                        </div>
                    </div>
                    <div class="reInfo">
                        <div class="reName multy2" v-text="item.name">

                        </div>
                        <div class="reTitle single" v-text="item.title">

                        </div>
                        <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
                            <div class="rebtn">
                                观看回放
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="titles flx alc jsb"  v-if="list3.length > 0">
                <div class="titleft">
                    在线学习
                </div>
                <img class="checkmopre cursor" :src="$Localimg('checkmore.png')" alt="" @click="checkMore(1)" />
            </div>
            <div class="listCon flx alc"  v-if="list3.length > 0">
                <div class="reItem" v-for="item,index in list3" :style="(index + 1) % 4 == 0?'margin-right:0' : ''" @click="toDetail(item)">
                    <div class="labelName" v-text="item.label" v-if="item.label"></div>
                    <div class="reImg">
                        <img :src="$img(item.pc_avatar)" alt="" />
                       <!-- <div class="reimgMask">
                            <img :src="$Localimg('play.png')" alt="">
                        </div> -->
                    </div>
                    <div class="reInfo">
                        <div class="reName multy2" v-text="item.name"></div>
                        <div class="reTitle single" v-text="item.title"></div>
                        <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
                            <div class="rebtn">
                                了解课程
                            </div>
                        <!--    <div class="rebtn dsb" v-if="item.current_time > item.over_time">
                                直播结束
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
            <el-pagination layout="prev, pager, next" :page-size="20" :current-page="page" @current-change="pageChange"
                :hide-on-single-page="true" :total="totals">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import {
        getLiveIndex,
        liverecommand
    } from "@/api/index.js"
    import banner from "@/components/banner.vue"
    export default {
        components: {
            banner
        },
        data() {
            return {
                bannerList: [],
                page: 1,
                totals: 0,
                list1: [],
                list2: [],
                list3: [],
				list5: [],
                current_time:0,
                cate1:[],
                category_id:0,
                recos:[]
            }
        },
        created() {
            this.getIndex()
        },
        watch: {
            '$route.query.category_id'(id) {
                if (id) {
                    this.scanThis(0, id)
                } else {
                    this.category_id = 0
                }
            }
        },
        methods: {
            scanThis(idx,id){
                console.log(id)
                let that = this 
                that.category_id = id
                getLiveIndex(id).then((Res) => {
                    if(Res.code == 1){
                         that.bannerList = Res.data.banner
                         that.current_time = Res.data.current_time
                         that.list1 = Res.data.list1
                         that.list2 = Res.data.list2
                         that.list3 = Res.data.list3
						 that.list5 = Res.data.list4
                    }
                })
            },
            checkMore(e){
                let that = this 
                that.$router.push({
                    path: '/livemore', // 写路由path
                    query: {
                        type:e,
                        id:that.category_id
                    }
                })
            },
            pageChange(e) {},
            toDetail(e){
                let that = this 
                this.$router.push({
                    path: '/liveDetail', // 写路由path
                    query: {
                        type:e.is_type,
                        id:e.id
                    }
                })
            },
            getIndex() {
                let that = this
                liverecommand().then((Res) => {
                    console.log(Res)
                    if (Res.code == 1) {
                        that.bannerList = Res.data.banner
                        that.cate1 = Res.data.category[0]
                        that.recos = Res.data.liveList
                        if (that.$route.query.category_id) {
                            that.scanThis(0, that.$route.query.category_id)
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .cateLeft{
        width: 40px;
        height: 40px;
        margin-right: 13px;
    }
    .cateLeft img{
        width: 100%;
        height: 100%;
    }
    .cactive{
        font-weight: 500 !important;
        color: #007AFF !important;
    }
    .caItem{
        margin-right: 40px;
        font-size: 14px;
        color: #4E5366;
    }
    .cateCon{
        flex: 1;
        flex-wrap: wrap;
    }
    .cateName{
      font-weight: 600;
      font-size: 15px !important;
      color: #202228;
    }
    .cateTitle{
        font-size: 13px;
        color: #53586C;
        margin-top: 6px;
        text-align: left;
    }
    .catesCon{
        width: 1460px;
        margin: 0 auto;
        background-color: #fff;
    }
    .cshu{
        width: 1px;
        height: 25px;
        background: #DFDFDF;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
    }
    .cateItem{
        padding: 10px 0;
        width: 20%;
        justify-content: center;
        position: relative;
        height: 80px !important;
        cursor: pointer;
    }
    .cates{
        width: 100%;
        background: #f8f8f8;
        box-sizing: border-box;
        padding: 12px 0;
        height: 100px !important;
        margin-bottom: 40px;
    }
    .labelName{
        height: 29px;
        background: linear-gradient( 79deg, #F59E0B 0%, #F4870A 100%);
        border-radius: 15px 15px 15px 2px;
        box-sizing: border-box;
        padding: 0 11px;
        line-height: 29px;
        position: absolute;
        left: 12px;
        top: 12px;
        font-weight: 600;
        font-size: 13px;
        color: #FFFFFF;
        z-index: 1;
    }
    .reImg {
        width: 344px;
        height: 194px;
        position:relative;
        overflow-y:hidden
    }
    
    .reimgMask{
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 3;
        background-color: rgba(0, 0, 0, .5);
    }
    
    .reimgMask img{
        width: 56px !important;
        height: 56px !important;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
    }

    .reImg img {
        width: 100%;
    }

    .rebtn {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
    }
    .dsb{
        background: #9CA3AF;
    }
    .reTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
        margin-top: 10px;
    }

    .reInfo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }

    .reName {
        height: 48px;
        line-height: 24px;
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }

    .relist {
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        padding-bottom: 56px;
    }

    .reItem {
        width: 344px;
        height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-bottom: 28px;
        overflow: hidden;
        margin-right: 28px;
        position: relative;
        cursor: pointer;
        flex-shrink: 0;
    }

    .listCon {
        flex-wrap: wrap;
    }

    .mains {
        width: 1460px;
        margin: 40px auto 0;
    }

    .titles {
        margin-bottom: 27px;
    }

    .checkmopre {
        width: 64px;
        /* height: 17px; */
    }

    .titleft {
        font-weight: 600;
        font-size: 24px;
        color: #000;
    }
</style>
